/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import moment from 'moment';
import { CustomOptionInterface, OptionInterface } from 'types';

export const generateOptionsFromString = (options: string[] | number[]): OptionInterface[] => {
    return (options ?? []).map((option) => ({
        value: option,
        label: String(option),
    }));
};

export const generateOptionFromObjectArray = (
    data: any[],
    label: string,
    value: string,
    hasOtherProps = false,
    groupKey?: string
) => {
    return data.reduce((acc, dataItem) => {
        acc.push({
            ...(hasOtherProps ? dataItem : {}),
            ...(groupKey ? { groupId: dataItem[groupKey] } : {}),
            value: value ? dataItem[value] : dataItem,
            // value: value ? get(dataItem, value) : dataItem,
            label: dataItem[label],
            // label: get(dataItem, label)
        });
        return acc;
    }, []);
};

export const generateOptionsFromArray = (options: string[] | number[]): OptionInterface[] => {
    return options.map((option) => ({
        value: option,
        label: String(option),
    }));
};

export const generateOptionFromObject = <T>(
    options: Record<string, T>
): CustomOptionInterface<T>[] => {
    return Object.entries(options).map(([key, value]) => ({
        label: key,
        value: value,
    }));
};

export const generateSelectOptions = <T>(
    options: T[],
    labelKey: keyof T,
    valueKey: keyof T
): CustomOptionInterface<T[keyof T]>[] => {
    return options.map((option) => ({
        label: String(option[labelKey]),
        value: option[valueKey],
    }));
};

export const formatDayjsDate = (date: string | null) => {
    if (!date) return undefined;
    return moment(date);
};

export const getPlainText = (value: string, characterToRemove = '_') => {
    return (value || '').split(characterToRemove).join(' ');
};
